import { toPersianDigits } from './digits.js';

/**
 * A numbered installment plan as every app reads it (D-111): «{length} {count} قسط», for example
 * «۴ ماهه ۳ قسط». Length D = installmentCount × intervalDays. «M ماهه» when D is within 5 days of
 * a whole number of 30-day months (M ≥ 1); otherwise «W هفته‌ای» when D is a whole number of
 * weeks; otherwise «D روزه». Persian digits. «N قسط» when the interval is missing. «پرداخت آخر ماه»
 * and unknown plan types are labelled by the caller.
 */
export function numberedPlanLabel(
  installmentCount: number,
  intervalDays: number | null | undefined,
): string {
  const count = `${toPersianDigits(installmentCount)} قسط`;
  if (intervalDays == null) {
    return count;
  }
  return `${planLengthFa(installmentCount, intervalDays)} ${count}`;
}

/** D-111 length word. Months win over weeks; both use Persian digits. */
function planLengthFa(installmentCount: number, intervalDays: number): string {
  const totalDays = installmentCount * intervalDays;
  const months = Math.round(totalDays / 30);
  if (months >= 1 && Math.abs(totalDays - months * 30) <= 5) {
    return `${toPersianDigits(months)} ماهه`;
  }
  if (totalDays >= 7 && totalDays % 7 === 0) {
    return `${toPersianDigits(totalDays / 7)} هفته\u200cای`;
  }
  return `${toPersianDigits(totalDays)} روزه`;
}
